const flashpostStateReducer = (flashpostState = 0, action) => {
    if (action.type === "FLASHPOST_CHANGE") {
      return action.payload;
    }
    return flashpostState;
  };
  
  export default flashpostStateReducer;